<template>
  <v-row>
    <v-col
      xs="6"
      sm="6"
      md="3"
      cols="6"
    >
      <SummaryItem
        class="tFolders"
        title="Total Folders"
        :value="getTotalFolders"
      />
    </v-col>
    <v-col
      xs="6"
      sm="6"
      md="3"
      cols="6"
    >
      <SummaryItem
        class="tItems"
        title="Total Items"
        :value="getTotalItems"
      />
    </v-col>
    <v-col
      xs="6"
      sm="6"
      md="3"
      cols="6"
    >
      <SummaryItem
        class="tQTY"
        title="Total Qty"
        :value="getTotalQTY"
      />
    </v-col>
    <v-col
      xs="6"
      sm="6"
      md="3"
      cols="6"
    >
      <SummaryItem
        class="tValue"
        title="Total Value"
        :value="getActiveWarehouse.currency.code + ' ' + formatPrice(getTotalValue)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import SummaryItem from '@/components/dashboard/SummaryItem'
export default {
  name: 'DashboardSummary',
  components: {
    SummaryItem
  },
  computed: {
    ...mapGetters('warehouses', ['getActiveWarehouse']),
    getTotalFolders() {
      return String(this.getActiveWarehouse.info?.countCategories || 0)
    },
    getTotalItems() {
      return String(this.getActiveWarehouse.info?.countItems || 0)
    },
    getTotalQTY() {
      return String(this.getActiveWarehouse.info?.totalQty || 0)
    },
    getTotalValue() {
      return String(this.getActiveWarehouse.info.totalValue || 0)
    }
  },
  methods: {
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
